import { useCallback, useState } from 'react';
import { platformService } from '../../../shared/services/platform.service';
import { getCommentsCount } from '../../ticketHelper';

/**
 * Manages the conversation comment count for the active ticket, aggregating
 * across merged ticket ids when present.
 */
export const useCommentsCount = (
  api: platformService,
  ticketId: number | string
) => {
  const [commentsCount, setCommentsCount] = useState<number>(0);

  const fetchCommentsCount = useCallback(
    async (mergedTicketIds: number[] = []) => {
      const ids = [...mergedTicketIds, parseInt(ticketId.toString())].join(',');
      const result = await api.getTicketComments(ids);
      setCommentsCount(getCommentsCount(result));
    },
    [api, ticketId]
  );

  return { commentsCount, setCommentsCount, fetchCommentsCount };
};
